<div class="d-flex flex-column table-container background-container mt-4">

  <div class="header-box">
    <div class="fixed-with-coloumn p-2" *ngFor="let name of DisplayedColumns">
      {{ name }}


    </div>
  </div>
  <div class="table-body-container">
    <div class="d-flex flex-column gap-1" *ngFor="let item of data">
      <div class="information-box border-colour">
        @if(AcessRole ==='DISTRIBUTOR' || AcessRole==='INSURER'  || AcessRole==='PROVIDER' ){
        <div class="fixed-with-coloumn p-2">
          <div class="fullname-wrapper gray-text">
            <div>{{ item.firstName }} {{ item.lastName }}</div>

            <div class="gray-text fs-11 mt-1">
              {{ item.dateOfBirth |age}} ,{{item.gender?.charAt(0)}}

            </div>
          </div>


        </div>

        <div class="fixed-with-coloumn p-2 gray-text"> {{item.yearsOfExperience || '-'}} </div>
        <div class="fixed-with-coloumn p-2 gray-text"> {{item.address || '-'}}
        </div>}
        @else {
        <div class="fixed-with-coloumn p-2">
          <div class="fullname-wrapper gray-text">


            <div class="gray-text fs-11 mt-1">
              {{ item.name || '-'}}

            </div>
          </div>


        </div>

        <div class="fixed-with-coloumn p-2 gray-text"> {{item.activeStartDate || '-'}} </div>
        <div class="fixed-with-coloumn p-2 gray-text"> {{item.mappedInsurers[0]?.name || '-'}}
        </div>

        }
        <div class="fixed-with-coloumn p-2 gray-text"> {{item.phone ||'-'}} </div>
        <div class="fixed-with-coloumn p-2 gray-text"> {{item.email ||'-'}} </div>

        <div class="fixed-with-coloumn p-2 gray-text">
          <app-status-lables [entityType]="enumEntityType.INSURER" [status]="item.isactive?'ACTIVE':'DEACTIVE'">
          </app-status-lables>
        </div>

        @if(AcessRole==='INSURER' || AcessRole==='PROVIDER' || AcessRole==='DISTRIBUTOR'){

        <div class="fixed-with-coloumn p-2 gray-text">
          <div class="action-buttons d-flex align-items-center gap-2">
            @if (!item.isactive) {
            <span class="icon-btn" matTooltip="Activate" matTooltipPosition="above"
              (click)="confirmStatusUpdateTrue.emit(item);$event.stopPropagation()">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <path fill="#53e643" fill-rule="evenodd"
                  d="M12 21a9 9 0 1 0 0-18a9 9 0 0 0 0 18m-.232-5.36l5-6l-1.536-1.28l-4.3 5.159l-2.225-2.226l-1.414 1.414l3 3l.774.774z"
                  clip-rule="evenodd" stroke-width="0.1" stroke="#53e643" />
              </svg>
            </span>
            } @else {
            <span class="icon-btn" matTooltip="Deactive" matTooltipPosition="above"
              (click)="confirmStatusUpdateFalse.emit(item);$event.stopPropagation()">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20">
                <path fill="#e84721" d="M10 20a10 10 0 1 1 0-20a10 10 0 0 1 0 20m5-11H5v2h10z" stroke-width="0.1"
                  stroke="#e84721" />
              </svg>
            </span>
            }

            <span class="icon-btn" matTooltip="Edit" matTooltipPosition="above"
              (click)="openinsurerAgentEdit.emit(item);$event.stopPropagation();">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 24 24">
                <path fill="#66AEE0" fill-rule="evenodd"
                  d="M21.455 5.416a.75.75 0 0 1-.096.943l-9.193 9.192a.75.75 0 0 1-.34.195l-3.829 1a.75.75 0 0 1-.915-.915l1-3.828a.8.8 0 0 1 .161-.312L17.47 2.47a.75.75 0 0 1 1.06 0l2.829 2.828a1 1 0 0 1 .096.118Z"
                  clip-rule="evenodd" stroke-width="0.1" stroke="#66AEE0" />
                <path fill="#66AEE0"
                  d="M19.641 17.16a44.4 44.4 0 0 0 .261-7.04a.4.4 0 0 1 .117-.3l.984-.984a.198.198 0 0 1 .338.127a46 46 0 0 1-.21 8.372c-.236 2.022-1.86 3.607-3.873 3.832a47.8 47.8 0 0 1-10.516 0c-2.012-.225-3.637-1.81-3.873-3.832a46 46 0 0 1 0-10.67c.236-2.022 1.86-3.607 3.873-3.832a48 48 0 0 1 7.989-.213a.2.2 0 0 1 .128.34l-.993.992a.4.4 0 0 1-.297.117a46 46 0 0 0-6.66.255a2.89 2.89 0 0 0-2.55 2.516a44.4 44.4 0 0 0 0 10.32a2.89 2.89 0 0 0 2.55 2.516c3.355.375 6.827.375 10.183 0a2.89 2.89 0 0 0 2.55-2.516Z"
                  stroke-width="0.1" stroke="#66AEE0" />
              </svg>
            </span>


          </div>
        </div> }




      </div>


    </div>


  </div>



</div>